/* eslint-disable react/no-unknown-property */
/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable array-callback-return */
/* eslint-disable no-debugger */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import moment from 'moment';
import { Calendar } from 'react-calendar';
import { createUrl } from '../../redux/helper/CreateQuery';
import { removeLastComma } from '../../redux/helper/RemoveComma';

function FilterModal({
    setfilter, threePL, territaryList, handleFiletr, selected, setselected,
}) {
    const toggleState = {
        start_date: false,
        end_date: false,
        offer_type: false,
        type: false,
    };
    const currentDate = moment(new Date()).format('YYYY/MM/DD');
    const dateRef = useRef();

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    const [toggle, settoggle] = useState(toggleState);
    const AddToSelect = (item, type) => {
        const arr = [...selected[type]];
        const index = arr.indexOf(item);
        if (index === -1) {
            arr.push(item);
        } else {
            arr.splice(index, 1);
        }
        setselected((prevState) => ({
            ...prevState,
            [type]: arr,
        }));
    };

    const handleStaustext = (status) => {
        let res = '';
        if (status.includes('0')) {
            res += 'Inactive,';
        }
        if (status.includes('1')) {
            res += 'Active,';
        }
        if (status.includes('-1')) {
            res += 'Draft,';
        }
        if (status.includes('-2')) {
            res += 'Expired,';
        }

        return res;
    };
    const generateUrl = (val) => {
        let final = '';
        Object.keys(selected).map((key) => {
            switch (key) {
            case 'destination_type':
                if (selected[key].length > 0) {
                    final += `&destination_type=${createUrl(selected[key])}`;
                }
                break;
            case 'status':
                if (selected[key].length !== 0) {
                    final += `&policy_status=${removeLastComma(handleStaustext(selected.status))}`;
                }
                break;
            default: break;
            }
        });
        if (selected.start_date !== '' && selected.end_date !== '') {
            final += `&date=${moment(selected.start_date).format('YYYY/MM/DD')}-${moment(selected.end_date).format('YYYY/MM/DD')}`;
        }
        if (val === undefined) {
            handleFiletr(final);
        }
        return final;
    };

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };
    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'end_date') {
            settoggle(toggleState);
        }
    };
    return (
        <div
            className="modal-dialog modal-dialog-centered relative max-w-[650px] pointer-events-none mt-0 mr-0 mb-0 h-full shadow-4xl bg-[#ffffff]"
        >
            <div
                className="modal-content border-none relative flex flex-col w-full pointer-events-auto bg-clip-padding outline-none text-current h-full"
            >
                <img
                    className="p-2 rounded-full cursor-pointer absolute top-4 right-4"
                    src="images/Component158–2.svg"
                    alt="close-icon"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setfilter(false)}
                />
                <div className="pt-[64px] pb-5 bg-[#ffffff]">
                    <div className="pl-[60px] sticky top-0 left-0 z-10 bg-[#FFFFFF] flex justify-between">
                        <div className="flex justify-between pr-5 items-center w-full">
                            <h2 className="text-xl font-bold text-[#555259]">
                                Filter (s)
                            </h2>
                            <div>
                                {(selected.start_date !== '' || selected.destination_type.length > 0 || selected.end_date !== '' || selected.status !== '') && (
                                    <p
                                        className="text-base text-[#555259] font-bold cursor-pointer pr-10"
                                        onClick={() => {
                                            setselected({
                                                destination_type: [],
                                                industrial_pocket: [],
                                                status: '',
                                                start_date: '',
                                                end_date: '',
                                            });
                                        }}
                                    >
                                        Clear
                                        {' '}

                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="px-14 bg-[#FFFFFF]">
                        <div className="mt-6 bg-[#F5F5FA] rounded-md px-2 pt-6 p-6">
                            <div>
                                <h5 className="text-base font-semibold text-[#555259]">Destination Type</h5>
                                <div className="px-1 mt-4">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-1414" checked={selected.destination_type.includes('Local')} onChange={() => AddToSelect('Local', 'destination_type')} />
                                        <label htmlFor="checkbox-1414" className="pl-3 text-base font-normal cursor-pointer text-[#555259]">Local</label>
                                    </div>
                                </div>
                                <div className="px-1 mt-1">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-1314" checked={selected.destination_type.includes('Outstation')} onChange={() => AddToSelect('Outstation', 'destination_type')} />
                                        <label htmlFor="checkbox-1314" className="pl-3 text-base font-normal cursor-pointer text-[#555259]">Outstation</label>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3">
                                <h5 className="text-base font-semibold text-[#555259]">Status</h5>
                                <div className="px-1 mt-4">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-1014" checked={selected.status.includes('1')} onChange={() => AddToSelect('1', 'status')} />
                                        <label htmlFor="checkbox-1014" className="pl-3 text-base font-normal cursor-pointer text-[#555259]">Active</label>
                                    </div>
                                </div>
                                <div className="px-1 mt-1">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-11014" checked={selected.status.includes('0')} onChange={() => AddToSelect('0', 'status')} />
                                        <label htmlFor="checkbox-11014" className="pl-3 text-base font-normal cursor-pointer text-[#555259]">Inactive</label>
                                    </div>
                                </div>
                                <div className="px-1 mt-1">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-110141" checked={selected.status.includes('-1')} onChange={() => AddToSelect('-1', 'status')} />
                                        <label htmlFor="checkbox-110141" className="pl-3 text-base font-normal cursor-pointer text-[#555259]">Draft</label>
                                    </div>
                                </div>
                                <div className="px-1 mt-1">
                                    <div className="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 custom-checkbox3 flex items-center">
                                        <input type="checkbox" id="checkbox-1101411" checked={selected.status.includes('-2')} onChange={() => AddToSelect('-2', 'status')} />
                                        <label htmlFor="checkbox-1101411" className="pl-3 text-base font-normal cursor-pointer text-[#555259]">Expired</label>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="mt-[18px] pb-10"
                                ref={dateRef}
                            >
                                <h5 className="text-base font-semibold text-[#555259]">Date Range</h5>
                                <div className="flex items-center mt-3">
                                    <div
                                        className="relative w-1/2"
                                        onClick={() => handleToggle('start_date')}
                                    >
                                        <label />
                                        <img
                                            src="images/Iconawesome-calendar-alt.svg"
                                            onClick={() => handleToggle('start_date')}
                                            alt="icon"
                                            className="absolute top-3 right-2.5 cursor-pointer"
                                        />
                                        <input
                                            datepicker
                                            datepicker-autohide
                                            value={selected.start_date === '' ? '' : moment(selected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                .join('/')}
                                            type="text"
                                            className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                            placeholder="Date From"
                                        />

                                    </div>
                                    {toggle.start_date && <Calendar value={moment(selected.start_date).format('YYYY/MM/DD').start_date} onChange={(val) => handleDate(val, 'start_date')} placeholder="Date from" />}

                                    <p className="text-base font-normal text-[#555259] px-2.5 pb-50">to</p>
                                    <div
                                        className="relative w-1/2"
                                        onClick={() => handleToggle('end_date')}
                                    >
                                        <label />
                                        <img
                                            src="images/Iconawesome-calendar-alt.svg"
                                            onClick={() => handleToggle('end_date')}
                                            alt="icon"
                                            className="absolute top-3 right-2.5 cursor-pointer"
                                        />
                                        <input
                                            value={selected.end_date === '' ? '' : moment(selected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                .join('/')}
                                            datepicker
                                            datepicker-autohide
                                            type="text"
                                            className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                            placeholder="Date To"
                                        />

                                    </div>
                                    {toggle.end_date && <Calendar value={selected.end_date} onChange={(val) => handleDate(val, 'end_date')} minDate={moment(selected.start_date).toDate()} placeholder="Date to" />}

                                </div>
                            </div>
                        </div>
                        <motion.button
                            animate={{ y: 10 }}
                            transition={{ delay: 1 }}
                            type="button"
                            className="mt-[22px] text-lg font-semibold text-[#FFFFFF] w-full h-[52px] rounded-[16px] bg-[#555259] mb-5"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => generateUrl()}
                        >
                            Apply Filter(s)
                        </motion.button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;
